export type LegalComercioSectionId = "datos" | "cancelacion" | "seguridad";

export interface LegalComercioSection {
  id: LegalComercioSectionId;
  title: string;
  body: string;
}

export interface LegalVendedorInfo {
  razonSocial: string;
  cif?: string | null;
  direccion?: string | null;
  poblacion?: string | null;
  codigoPostal?: string | null;
  telefono?: string | null;
  email?: string | null;
}

/** Texto legal de comercio electrónico (LSSI / condiciones de pago). */
export const LEGAL_COMERCIO_SECTIONS: LegalComercioSection[] = [
  {
    id: "datos",
    title: "Datos identificativos",
    body: "En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos: el titular de dominio web www.circuitcover.com es propiedad de Ivan Garrido Pere-Rubio con el nombre comercial CircuitCover, NIF: 50726817H, domiciliado en Avda. Europa 12 1ºA, 28863 Cobeña, Madrid. Correo electrónico de contacto: info@circuitcover.com y teléfono: +34625153302",
  },
  {
    id: "cancelacion",
    title: "Política de cancelación/devolución",
    body: "No se aceptarán devoluciones una vez comenzado el periodo al que se refiere el pago y habiendo ocurrido un siniestro. Antes de que comience el pedido podrás avisar por correo electrónicos info@circuitcover.com se hará la devolución en un máximo de 7 días hábiles por el mismo método de pago que usaste.",
  },
  {
    id: "seguridad",
    title: "Seguridad y protección a compradores",
    body: "Los cobros se hacen en un entorno seguro que cumple los protocolos SSL. Se utiliza en las pasarelas de pago el sistema 3DSecure redirigiendo los datos a servidores seguros sin que el comercio pueda acceder a ellos o almacenarlos).",
  },
];

export const DATOS_IDENTIFICATIVOS_CIRCUIT_COVER = LEGAL_COMERCIO_SECTIONS[0]!.body;

export function buildDatosIdentificativosBody(vendedor?: LegalVendedorInfo | null): string {
  if (!vendedor?.razonSocial) {
    return DATOS_IDENTIFICATIVOS_CIRCUIT_COVER;
  }

  const partes: string[] = [
    "En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos del vendedor:",
    `${vendedor.razonSocial}${vendedor.cif ? `, CIF/NIF: ${vendedor.cif}` : ""}.`,
  ];

  const domicilio = [vendedor.direccion, vendedor.poblacion, vendedor.codigoPostal]
    .filter(Boolean)
    .join(", ");
  if (domicilio) {
    partes.push(`Domicilio: ${domicilio}.`);
  }
  if (vendedor.email) {
    partes.push(`Correo electrónico de contacto: ${vendedor.email}.`);
  }
  if (vendedor.telefono) {
    partes.push(`Teléfono: ${vendedor.telefono}.`);
  }

  return partes.join(" ");
}

export const LEGAL_COMERCIO_MODAL_TITLE = "Información legal y condiciones de compra";
